import {createSinglePathSVG} from './TEMPLATE'

export const PlusLarge_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 3a1 1 0 0 1 1 1v7h7a1 1 0 1 1 0 2h-7v7a1 1 0 1 1-2 0v-7H4a1 1 0 1 1 0-2h7V4a1 1 0 0 1 1-1Z',
})

export const PlusSmall_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 6a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H7a1 1 0 1 1 0-2h4V7a1 1 0 0 1 1-1Z',
})
